<template>
    <div>
        <div class="header_warpper">
            <div class="user-info-cont">
                <!-- <div class="welcome">欢迎使用天宝软件</div> -->
                <div class="welcome_t">{{ getDateha() }}，{{ getWeek() }}</div>
            </div>
            <div class="user-info">
                <img v-if="userInfo.img" :src="userInfo.img" class="user-avator" alt="" />
                <img v-else src="../../assets/img/img.png" class="user-avator" alt />
                <div class="user-info-name">{{ userInfo.staffr_name }}，您好！</div>
            </div>
        </div>
        <div class="center_warpper">
            <div class="offen_m">
                <div slot="header" class="clearfix">
                    <span>用户常用模块</span>
                </div>
                <div class="offen_item">
                    <div class="normal" v-for="(item, index) in normalArr" :key="index" @click="gotoPage(item.code)">
                        <i :class="item.word_name.echinese" v-if="item.word_name.echinese"></i>
                        <i class="el-icon-connection" v-else></i>
                        <p>{{ item.word_name.chinese }}</p>
                    </div>
                </div>
            </div>
            <div class="sys_o">
                <div slot="header" class="clearfix">
                    <span>系统公告</span>
                </div>
                <div class="sys_warpper" v-if="todoList2.length > 0">
                    <div v-for="item of todoList2" :key="item.id" @click="handleRead(item)">
                        <p>{{ item.title }}</p>
                        <p>{{ item.send_addtime }}</p>
                    </div>
                </div>
                <div v-else class="noinfo">
                    <img src="@/assets/img/noinfo.png" alt="" />
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="footer_t">
                <!-- <div class="hot">
                    <div slot="header" class="clearfix">
                        <span>热门推送</span>
                    </div>
                    <div class="nav">
                        <el-carousel indicator-position="outside" height="220px">
                            <el-carousel-item v-for="item in swiperList" :key="item">
                                <img :src="item" alt="" />
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div> -->
                <div class="myinfo">
                    <div slot="header" class="clearfix">
                        <span>我的消息</span>
                    </div>
                    <div class="info_item" v-if="todoList.length > 0">
                        <div v-for="item of todoList" :key="item.id" @click="handleRead(item)">
                            <p>{{ item.title }}</p>
                            <p>{{ item.send_addtime }}</p>
                        </div>
                    </div>
                    <div v-else class="noinfo">
                        <img src="@/assets/img/noinfo.png" alt="" />
                    </div>
                </div>
            </div>
            <div class="propose">
                <div slot="header" class="clearfix">
                    <span>意见反馈</span>
                </div>
                <div style="margin-top: 20px">
                    <el-input
                        v-model="propose.text"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入需求、改进建议，反馈程序缺陷及投诉、举报，200字以内"
                    ></el-input>
                    <el-input v-model="propose.phone" placeholder="请输入手机号或固定号码" type="tel" style="margin: 15px 0"></el-input>
                    <el-upload
                        class="upload-demo"
                        :action="uploadAction"
                        :data="uploadData"
                        :headers="headers"
                        :before-remove="beforeRemove"
                        :on-success="success"
                        :limit="3"
                        :on-exceed="handleExceed"
                        ref="upload"
                    >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">仅限jpg/png</div>
                    </el-upload>
                    <div @click="submit" class="submit">立即提交</div>
                </div>
            </div>
        </div>
        <!-- <div class="foot">Copyright © 2023 深圳市物华天宝软件有限公司</div> -->

        <el-dialog style="padding: 0 20px" title="详情" :visible.sync="outData.isshow" width="60%">
            <el-form class="editda" label-width="100px">
                <el-form-item label="发布人：">
                    <span v-text="outData.data.send_user_no"></span>
                </el-form-item>
                <el-form-item label="时间：">
                    <span v-text="outData.data.send_addtime"></span>
                </el-form-item>
                <el-form-item label="标题：">
                    <span v-text="outData.data.title"></span>
                </el-form-item>
                <el-form-item label="内容：">
                    <span v-html="outData.data.content"></span>
                    <span style="color: rgb(136, 19, 145); cursor: pointer" @click="clickCheck" v-if="outData.data.url_c">点击查看</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="outData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Utils from '../../assets/util.js';
import {
    apiGetinfo,
    apiSystemModuleOften,
    apiNoticeIndex,
    apiNoticeDetail,
    apiOnline,
    apiNoticeNum,
    apiIndexAll,
    apiSystem,
    apiUpload,
    ideaAdd
} from '@/request/api'; // 导入我们的api接口
import $timer from '../../utils/timer';
export default {
    name: 'dashboard',
    data() {
        return {
            userInfo: '',
            normalArr: [],
            todoList: [],
            todoList2: [],
            todoDetail: [],
            outData: { isshow: false, scope: null, index: 0, data: {} },
            online: '',
            allMessage: '',
            systemSet: '',
            propose: {
                text: '',
                phone: ''
            },
            swiperList: [],
            uploadaction: '',
            uploadData: { url: 'index' },
            headers: {},
            fileList: []
        };
    },
    computed: {},
    created: function () {
        this.uploadAction = this.$baseURL + 'upload_img';
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;

        this.getAllInfo();
        this.getSystem();

        // 60s获取一次人数
        // setTimeout(() => {
        //     if (sessionStorage.getItem('onlines')) {
        //         this.online = JSON.parse(sessionStorage.getItem('onlines')).online_sum || 0;
        //     }
        // }, 1000);
        // setInterval(() => {
        //     this.online = JSON.parse(sessionStorage.getItem('onlines')).online_sum || 0;
        // }, 60000);
    },
    methods: {
        success(file, fileList) {
            this.fileList.push({
                name: fileList.name,
                url: file.data.imgs
            });
        },
        beforeRemove(file, fileList) {
            this.fileList = this.fileList.filter((item) => item.name != file.name);
        },
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        },

        submit() {
            if (!this.propose.text) {
                this.$message('请填写反馈建议');
                return;
            }
            let imgArr = [];
            this.fileList.forEach((item) => {
                imgArr.push(item.url);
            });
            var imgStr;
            if (imgArr.length > 0) {
                imgStr = imgArr.join(',');
            } else {
                imgStr = '';
            }
            this.$load.show();
            ideaAdd({
                title: this.propose.text,
                phone: this.propose.phone,
                img: imgStr
            }).then((res) => {
                this.$load.close();
                if (res.code == 2000) {
                    this.$message.success(res.data);
                    this.propose.text = '';
                    this.propose.phone = '';
                    this.fileList = [];
                    this.$refs.upload.clearFiles();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        getAllInfo() {
            apiIndexAll({
                type_name: localStorage.getItem('type'),
                type: localStorage.getItem('type')
            }).then((res) => {
                if (res.code == 2000) {
                    this.userInfo = res.data.user_info.data;
                    this.normalArr = res.data.recentuse_user_list.data;
                    this.todoList = res.data.notice_index.data;
                    this.todoList2 = res.data.system_notice_index.data;
                    this.allMessage = res.data.notice_index_read.data;
                    this.swiperList = res.data.imgs.data;
                    // this.online=res.data.online_number.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getDateha() {
            var year = new Date().getFullYear();
            var month = new Date().getMonth() + 1;
            var day = new Date().getDate();
            var str = '今天是' + year + '年' + month + '月' + day + '日';
            return str;
        },
        getWeek() {
            var week = new Date().getDay(),
                arr = ['日', '一', '二', '三', '四', '五', '六'],
                str = '星期' + arr[week];
            return str;
        },
        // 详情 ->拼接内容 点击查看
        clickCheck() {
            this.$set(this.outData, 'isshow', false);
            const { url_c } = this.outData.data;
            this.$router.push({ name: url_c.url_c, params: url_c.params });
        },
        getNormal() {
            apiSystemModuleOften({
                type: localStorage.getItem('type')
            }).then((res) => {
                if (res.code == 2000) {
                    this.normalArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getNotice() {
            apiNoticeIndex({
                type: '普通公告'
            }).then((res) => {
                if (res.code == 2000) {
                    this.todoList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getNoticeS() {
            apiNoticeIndex({
                type: '系统公告'
            }).then((res) => {
                if (res.code == 2000) {
                    this.todoList2 = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getNoticeNum() {
            apiNoticeNum({}).then((res) => {
                if (res.code == 2000) {
                    this.allMessage = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleRead(scope) {
            this.outData.isshow = true;
            scope.is_read = 1;
            apiNoticeDetail({
                id: scope.send_id,
                send_type: this.$bus.data.type
            }).then((res) => {
                if (res.code == 2000) {
                    this.outData.data = res.data;
                    Utils.$emit('demo', 'msg');
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //常用模块跳转
        gotoPage(code) {
            //
            this.$router.push('/' + code);
        },
        getOnline() {
            apiOnline({}).then((res) => {
                if (res.code == 2000) {
                    // this.online=res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                    localStorage.setItem('systemSet', JSON.stringify(res.data));
                } else {
                    this.$message.error(res.data.info);
                }
            });
        }
    }
};
</script>

<style scoped>
.foot {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
    font-size: 14px;
}
.noinfo {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    float: left;
}
.noinfo img {
    height: 70%;
}
.el-row {
    margin-bottom: 20px;
    height: 136px;
}
.indexPic {
    display: flex;
    align-items: center;
}
.indexPic span {
    display: block;
    color: gray;
}
/* .indexPic span:first-child {
    font-size: 13px;
} */
.indexPic i {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: gray;
}

.user-info {
    display: flex;
    flex-direction: column;
}

.user-avator {
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
/* 
.user-info-cont {
    flex: 1;
    font-size: 14px;
    color: #999;
    margin-left: 20px;
    height: 100%;
}

.user-info-cont div:first-child {
    font-size: 18px;
    color: #222;
} */

.mgb20 {
    margin-bottom: 20px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}
.el-card {
    border: none;
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
    box-shadow: none;
}
.normal {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}
.normal span {
    width: 30%;
    display: inline-block;
    text-align: left;
    padding: 5px 0;
}
.normal span:hover {
    color: #409eff;
}
</style>
<style>
.editda img {
    width: 100%;
}
.el-upload--text {
    width: auto;
    height: auto;
    border: none;
}
.el-upload-list {
    width: 100%;
}
</style>
<style lang="scss" scoped>
/* 修改样式 */
.header_warpper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    margin-bottom: 15px;
    .welcome {
        color: #0084ff;
        font-size: 24px;
    }
    .welcome_t {
        font-size: 16px;
        color: #333;
    }
}
.user-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .user-info-name {
        font-size: 16px;
    }
}
.center_warpper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 272px;
    margin-bottom: 15px;
    .offen_m {
        background-color: #fff;
        width: 70%;
        height: 100%;
        padding: 15px;
        box-sizing: border-box;
        .offen_item {
            display: flex;
            width: fit-content;
            flex-wrap: wrap;
            width: 100%;

            .normal {
                width: 12.5%;
                display: flex;
                flex-direction: column;
                align-items: center;
                font-size: 14px;
                margin-top: 40px;
                color: #666;
                cursor: pointer;
            }
            i {
                font-size: 24px;
                margin-bottom: 5px;
                height: 24px;
            }
        }
    }
    .sys_o {
        width: 29%;
        background-color: #fff;
        height: 100%;
        padding: 15px;
        box-sizing: border-box;
        .clearfix {
            margin-bottom: 20px;
        }
        .sys_warpper {
            width: 100%;
            cursor: pointer;
            div {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                margin: 5px 0;
                color: #333;
                &:hover p {
                    color: #0084ff !important;
                }
                p {
                    &:nth-child(2) {
                        color: #666;
                    }
                }
            }
        }
    }
}
.footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 392px;
    .footer_t {
        width: 70%;
        display: flex;
        justify-content: space-between;
        height: 100%;
        .hot {
            width: 49.5%;
            height: 100%;
            background-color: #fff;
            padding: 15px;
            box-sizing: border-box;
            .nav {
                width: 100%;
                margin-top: 20px;
                img {
                    width: 98%;
                    height: auto;
                }
            }
        }
        .myinfo {
            width: 49.5%;
            height: 100%;
            background-color: #fff;
            padding: 15px;
            box-sizing: border-box;
            .info_item {
                cursor: pointer;
                margin-top: 20px;
                div {
                    display: flex;
                    justify-content: space-between;
                    font-size: 14px;
                    color: #666;
                    border-bottom: 1px solid #dcdfe6;
                    padding: 10px 0;
                    &:hover p {
                        color: #0084ff !important;
                    }
                    p {
                        &:nth-child(2) {
                            color: #666;
                        }
                    }
                }
            }
        }
    }
    .propose {
        width: 29%;
        height: 100%;
        background-color: #fff;
        padding: 15px;
        box-sizing: border-box;
        .upload-demo {
            display: flex;
            flex-wrap: wrap;
            .el-upload__tip {
                font-size: 14px;
                color: #c0c4cc;
                margin-left: 10px;
                width: 70%;
            }
        }
        .submit {
            width: 100%;
            height: 36px;
            border: 1px solid #dcdfe6;
            border-radius: 4px 4px 4px 4px;
            font-size: 16px;
            color: #666;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            cursor: pointer;
        }
    }
}
</style>
